
import { instantiate } from './Ktor-MQTT-mqtt-client-ws.uninstantiated.mjs';


const exports = (await instantiate({
})).exports;

export const {
memory,
_initialize
} = exports


